import { render, staticRenderFns } from "./UcuncuTarafForm.vue?vue&type=template&id=3dbd3999"
import script from "./UcuncuTarafForm.vue?vue&type=script&lang=ts"
export * from "./UcuncuTarafForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports